import PropTypes from 'prop-types'
import { Element } from '../../../../../common/html/element'
import classes from './index.module.scss'

export const Layout = ({ renderLeft, renderRight, renderTitle }) => {
  return (
    <div className={classes.container}>
      <div className="w60 h100">{renderLeft()}</div>
      <div className="w40 h100 flexColumn py1">
        <Element className={classes.rightTitle} style={{ fontSize: 14 }}>
          {renderTitle()}
        </Element>
        {renderRight()}
      </div>
    </div>
  )
}

Layout.propTypes = {
  renderLeft: PropTypes.func.isRequired,
  renderRight: PropTypes.func.isRequired,
  renderTitle: PropTypes.func,
}

Layout.defaultProps = {
  renderTitle: () => {},
}
